/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.queryEvents'

export { $nsid }

/** List moderation events related to a subject. */
const main = l.query(
  $nsid,
  l.params({
    types: l.optional(l.array(l.string())),
    createdBy: l.optional(l.string({ format: 'did' })),
    sortDirection: l.optional(l.withDefault(l.enum(['asc', 'desc']), 'desc')),
    createdAfter: l.optional(l.string({ format: 'datetime' })),
    createdBefore: l.optional(l.string({ format: 'datetime' })),
    subject: l.optional(l.string({ format: 'uri' })),
    collections: l.optional(
      l.array(l.string({ format: 'nsid' }), { maxLength: 20 }),
    ),
    subjectType: l.optional(l.string<{ knownValues: ['account', 'record'] }>()),
    includeAllUserRecords: l.optional(l.withDefault(l.boolean(), false)),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    hasComment: l.optional(l.boolean()),
    comment: l.optional(l.string()),
    addedLabels: l.optional(l.array(l.string())),
    removedLabels: l.optional(l.array(l.string())),
    addedTags: l.optional(l.array(l.string())),
    removedTags: l.optional(l.array(l.string())),
    reportTypes: l.optional(l.array(l.string())),
    policies: l.optional(l.array(l.string())),
    modTool: l.optional(l.array(l.string())),
    batchId: l.optional(l.string()),
    ageAssuranceState: l.optional(
      l.string<{
        knownValues: ['pending', 'assured', 'unknown', 'reset', 'blocked']
      }>(),
    ),
    withStrike: l.optional(l.boolean()),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    events: l.array(
      l.ref<ModerationDefs.ModEventView>(
        (() => ModerationDefs.modEventView) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
